import { toastError, toastSuccess } from 'admination-react'
import { ModalAction } from '../ModalAction'
import { useCoachingString } from '../useCoachingString'
import { friendlyErrorMessage } from '@/core/lib/dbError'
import { useState } from 'react'
import { useApp } from '@/core/state/appStore'

import { AskModal } from '@/core/components/ui/ask-modal'
import { getZertifikatPath, sendZertifikat } from '../../../flows/zertifikat'
import { ModalHeader } from '@/core/components/modal/ModalHeader'
import { PdfRegion } from '@/core/components/modal/PdfRegion'

export function ZertifikatDokument({ coachingId }: { coachingId: string | null }) {
  const { reloadDashboard } = useApp()
  const [sending, setSending] = useState(false)
  const [confirmOpen, setConfirmOpen] = useState(false)

  const [path] = useCoachingString(coachingId, getZertifikatPath)

  async function send() {
    if (!coachingId || sending) return
    setSending(true)
    try {
      const link = await sendZertifikat(coachingId)
      toastSuccess(`Zertifikat an ${link.sent_to} gesendet.`)
      reloadDashboard()
      setSending(false)
      setConfirmOpen(false)
    } catch (e) {
      console.error("Zertifikat senden fehlgeschlagen:", e)
      toastError(
        friendlyErrorMessage(e, "Zertifikat konnte nicht gesendet werden. Bitte versuchen Sie es erneut."),
      )
      setSending(false)
      setConfirmOpen(false)
    }
  }

  return (
    <>
      <ModalHeader size="document">
        <div className="pill-cluster">
          <ModalAction
            icon="i-send"
            primaryAction
            title="Senden"
            onClick={() => setConfirmOpen(true)}
            loading={sending}
            disabled={path === undefined || !path || sending}
          />
        </div>
      </ModalHeader>
      <AskModal
        open={confirmOpen}
        icon="i-send"
        iconStroke
        variant="is-info"
        question="Anwesenheitsliste und Zertifikat an den/die Teilnehmende:n senden?"
        description="Die Anwesenheitsliste und das Zertifikat werden im Teilnehmer-Portal sichtbar und der/die Teilnehmende:r erhält eine E-Mail mit dem Zugangslink."
        confirmLabel="Ja"
        cancelLabel="Nein"
        busy={sending}
        onConfirm={() => void send()}
        onCancel={() => setConfirmOpen(false)}
      />
      <PdfRegion
        path={path ?? null}
        waiting={path === undefined}
        loadingLabel="Zertifikat wird geladen …"
        placeholder="Noch kein Zertifikat vorhanden."
      />
    </>
  )
}
